import { jsx as _jsx } from "react/jsx-runtime";
const Spinner = ({ styles }) => {
    return (_jsx("div", { className: "spinner-container", style: { ...styles }, children: _jsx("div", { className: "spinner" }) }));
};
export default Spinner;
